import React from 'react';
import './Columns.scss';

const Columns = ({ children, borders }) => {
  return (
    <div borders={borders.toString()} className="columns-container">
      {children &&
        children.map((child, i) => (
          <div className={`${borders ? 'has-borders' : ''}`} key={i}>
            {child}
          </div>
        ))}
    </div>
  );
};

export default Columns;
